import styled, { css } from "styled-components"
import { AnimationDismissType, FLOATING_BUTTON_DURATION_IN_SECONDS } from "../burnout-animation-constants";

interface IBurnoutAnimationBoxProps {
    animationEnded: boolean;
    dismissType: AnimationDismissType;
}

export const BurnoutAnimationBox = styled.div<IBurnoutAnimationBoxProps>`
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-70%);
    ${({animationEnded, theme}) => animationEnded ? css`
        background-image: url(${theme.images.burnoutAnimation.lastFrame.toString()});
        background-position: 0 0;
        background-size: 100% 100%;
    ` : ""}

    /* Aspect ratio. 1000 / 600 = 1.(6) => In percentage 166.(6)% */
    height: 0;
    padding-top: calc(166.66667%);
    ${({animationEnded, dismissType}) => (animationEnded && dismissType === AnimationDismissType.FloatingButton) ? css`
        transition: transform ${FLOATING_BUTTON_DURATION_IN_SECONDS}s;
        transform: translateY(-90%) scale(2);
        @media ${({theme}) => theme.mediaQuery.lAndAbove } {
            transform: translate(-3%, -100%) scale(2.5);
        }
    ` : ""}
`;
